import { PinnedProduct } from '../types/PinnedProduct';
import { buildValidationResult, PinnedProductValidationResult } from '../types/PinnedProductValidationResult';

export const validatePinnedProductConfiguration = (configuration: unknown): boolean => {
  try {
    if (!configuration || typeof configuration !== 'object') {
      return false;
    }

    const config = configuration as Record<string, unknown>;

    if (!validateProducts(config)) {
      return false;
    }

    if (!validateSchedule(config)) {
      return false;
    }

    return true;
  } catch {
    return false;
  }
};

export const validatePinnedProductsMerge = (
  existingProducts: PinnedProduct[],
  toBeMergedProducts: PinnedProduct[]
): PinnedProductValidationResult => {
  const resultingArray = [...existingProducts, ...toBeMergedProducts];

  if (new Set(resultingArray.map((x) => x.position)).size !== resultingArray.length) {
    return buildValidationResult(false, 'The resulting list of pinned products would contain duplicated positions');
  }
  if (new Set(resultingArray.map((x) => x.mpvId)).size !== resultingArray.length) {
    return buildValidationResult(false, 'The resulting list of pinned products would contain duplicated MPV IDs');
  }

  return buildValidationResult(true, '');
};

const validateSchedule = (configuration: Record<string, unknown>): boolean => {
  if (!configuration.schedule || typeof configuration.schedule !== 'object') {
    return false;
  }

  const schedule = configuration.schedule as Record<string, unknown>;

  if (!('enabled' in schedule) || typeof schedule.enabled !== 'boolean') {
    return false;
  }

  if ('startDate' in schedule && !(new Date(schedule.startDate as string) instanceof Date)) {
    return false;
  }

  if ('endDate' in schedule && !(new Date(schedule.endDate as string) instanceof Date)) {
    return false;
  }

  return true;
};

const validateProducts = (configuration: Record<string, unknown>): boolean => {
  if (!('products' in configuration) || !Array.isArray(configuration.products)) {
    return false;
  }

  if (
    !configuration.products.every((product: PinnedProduct) => {
      return validateMpvId(product) && validatePosition(product);
    })
  ) {
    return false;
  }

  return true;
};

const validateMpvId = (product: PinnedProduct): boolean => {
  return 'mpvId' in product && typeof product.mpvId === 'string' && product.mpvId !== '';
};

const validatePosition = (product: PinnedProduct): boolean => {
  return 'position' in product && typeof product.position === 'number' && product.position > 0;
};
